import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
    issuer: environment.wso2URL+'/oauth2/token',
    redirectUri: window.location.origin + '/login-callback',
    clientId: environment.clientId,
    responseType: environment.responseType,
    scope: environment.scopes,
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    logoutUrl: environment.wso2LogoutURL, // WSO2 logout endpoint
    postLogoutRedirectUri: window.location.origin + '/logout-callback',
    useSilentRefresh: false
};